import { AcornsIcon } from '@acorns/icons'
import { Bodytext, Title } from '@acorns/web-components'
import styled from 'styled-components'

import { style } from 'theme'

export const StyledInvestListContainer = styled.ul`
  margin: 0;
  padding-left: 19px;
`

export const StyledInvestListItem = styled.li`
  max-width: 250px;
  line-height: 25px;
`

export const ContentContainer = styled.div<{ marginBottom?: string }>`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  margin-bottom: ${props => (props.marginBottom ? props.marginBottom : '40px')};
`

export const ContentBodyText = styled(Bodytext)<{ marginBottom?: string }>`
  font-size: 16px;
  line-height: 24px;
  ${props => props.marginBottom && `margin-bottom:${props.marginBottom};`}
`

export const ContentTitle = styled(Title)<{
  fontSize?: string
  lineHeight?: string
}>`
  font-size: ${props => (props.fontSize ? props.fontSize : '22px')};
  line-height: ${props => (props.lineHeight ? props.lineHeight : '30px')};
  margin-bottom: 10px;
  font-weight: 600;
`

export const RecommendedPortfolioTitle = styled(Title)`
  font-size: 14px;
  line-height: 22px;
  color: ${style(theme => theme.colors.stone)};
  margin-bottom: 5px;
  font-weight: 600;
`

export const SubContentTitle = styled(Title)`
  font-size: 16px;
  line-height: 24px;
  font-weight: 600;
  margin-bottom: 5px;
`

export const AboutIcon = styled(AcornsIcon)`
  margin-bottom: 40px;
`

export const Footer = styled(Bodytext)`
  font-size: 14px;
  line-height: 22px;
  padding-bottom: 20px;
  color: ${style(theme => theme.colors.stone)};
`
